export default "EHPAD et médico-social publics : confort thermique 24h/24, décret tertiaire et primes CEE. Diagnostic et plan d'actions pour votre patrimoine.";
